import { getMessagingAccessTokenDocument } from '../../../firebase/gql/getMessagingAccessTokenDocument';
import * as yup from 'yup';
import { throttle } from 'lodash';
import { client } from './client';

const responseDataSchema = yup.object().shape({
    data: yup.object().shape({
        getMessagingAccessToken: yup.object().shape({
            expireAt: yup.number().required(),
            jwt: yup.string().required(),
        }),
    }),
});

type FetchTokenResponse = {
    expireAt: number;
    jwt: string;
};

export const fetchFirebaseTokenGraphQL = throttle(async (): Promise<FetchTokenResponse> => {
    const response = await client.mutate({
        mutation: getMessagingAccessTokenDocument,
        variables: {},
        context: {
            headers: {
                'Content-Type': 'application/json',
            },
        },
    });

    const validResponse = await responseDataSchema.validate(response);

    return validResponse.data.getMessagingAccessToken;
}, 2000);
